import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { IGridOneColumnBlock } from './grid-one-column.model';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { computedGridColumnClasses } from '../grid.utils';
import { gridInputTransform } from '../grid-input.transform';
import { NgClass } from '@angular/common';

@Component({
    selector: 'div[s1-grid-one-column]',
    imports: [CmsComponent, NgClass],
    templateUrl: './grid-one-column.component.html',
    styleUrl: './grid-one-column.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'grid grid-cols-12',
        '[class]': 'classes()',
    },
})
export class GridOneColumnComponent {
    private _tailwind = inject(TailwindService);

    // @ts-expect-error - transform works - fix later typing
    block = input.required<IGridOneColumnBlock>({ transform: gridInputTransform<IGridOneColumnBlock> });
    classes = computed(() => {
        const block = this.block();
        return [
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getDisplayClasses(block, 'grid'),
        ];
    });

    column1Classes = computed(() => {
        const block = this.block();
        return [
            ...this._tailwind.getGapClasses(block),
            ...this._tailwind.getColSpanClasses(computedGridColumnClasses(1, block))
        ];
    });
}
